import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import api from '../../utils/api';

export default function SlipTemplatePreviewModal({
  open,
  onOpenChange,
  category,
  template,
  schoolId,
}) {
  const [loading, setLoading] = useState(false);
  const [html, setHtml] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !template?.id || !schoolId) return;
    let cancelled = false;
    setLoading(true);
    setError('');
    setHtml('');
    api
      .get('/slips/templates/preview', {
        params: { category, template_id: template.id, school_id: schoolId },
      })
      .then((res) => {
        if (cancelled) return;
        const payload = res.data?.data;
        const raw = typeof payload === 'string' ? payload : payload?.html;
        setHtml(raw || '');
        if (!raw) {
          setError('Preview HTML was empty');
        }
      })
      .catch((e) => {
        if (cancelled) return;
        const msg = e?.response?.data?.message
          || (typeof e?.response?.data === 'string' ? e.response.data : null)
          || 'Failed to load preview';
        setError(msg);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, template?.id, category, schoolId]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-border text-foreground max-w-5xl w-[95vw] h-[85vh] overflow-hidden p-0">
        <div className="p-6 border-b border-border">
          <DialogHeader>
            <DialogTitle>
              Preview — {template?.name || 'Template'}
            </DialogTitle>
            <p className="text-sm text-muted-foreground">
              {category === 'salary_slip' ? 'Salary slip print preview' : 'Fee receipt print preview'}
            </p>
          </DialogHeader>
        </div>
        <div className="h-[calc(85vh-92px)] bg-muted/20">
          {loading ? (
            <div className="h-full flex items-center justify-center text-sm text-muted-foreground">
              Loading preview…
            </div>
          ) : error ? (
            <div className="h-full flex items-center justify-center text-sm text-red-400">
              {error}
            </div>
          ) : (
            <iframe
              title="slip-preview"
              className="w-full h-full bg-white"
              sandbox="allow-same-origin"
              srcDoc={html}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

